import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-wizard",
  "use": "icon-leo-wizard-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-wizard\">\r\n<g transform=\"translate(-113.571 -74.473) scale(1.221818)\">\r\n<path d=\"M480 128h64v192h192v64H544v192h-64V384H288v-64h192V128z\" />\r\n  <path d=\"M256 640h512v192H256V640zm96 64v64h320v-64H352z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-wizard.svg
// module id = ocAk
// module chunks = 396